module.exports = __webpack_public_path__ + "media/map/marker-9238ec94.svg";